<template lang="pug">
	div(id="admin")
		div
			p(class="btn btn-sm btn-link"  @click="m_goToMain()") Return to App
			b-nav(tabs vertical class="text-left")
				b-nav-text User Managment
				b-nav-item(:active="d_pgKey=='AU'" @click="d_pgKey='AU'") App Users
				b-nav-text App Maintenance
				b-nav-item(:active="d_pgKey=='RC'" @click="d_pgKey='RC'") Cache
		div(class="border")
			div(class="bg-light text-danger px-2 py-1 mb-1") 		
				span  Admin
			div(v-if="d_pgKey=='AU'" class="small px-1")
				//- Header
				div(class="hdr")
					b-button(variant="primary" @click="m_addAU()") Add User
					b-button(variant="outline-secondary" @click="m_refresh()") Refresh
				//- Table
				b-table-simple(small hover)
					b-thead
						b-th(class="th-edit")
						b-th(class="th-id") User Id
						b-th User Name
						b-th User Sub
						b-th(class="th-chkBox") Disabled
						b-th Last Log In
						b-th Team Member #
						b-th Team Member Name
						b-th Email
					b-tbody
						b-tr(v-for="(row,ixr) in d_auData" :key="ixr")
							b-td
								span(class="btn btn-link" @click="m_editAU(row, ixr)") Edit
							b-td {{row.appUserId}}
							b-td {{row.userName}}
							b-td {{row.userSub}}
							b-td
								input(type="checkbox"  :checked="row.disabled" class="ml-3")
							b-td {{d_util.fn_fmtDtmStr(row.lastLogInUTC, true)}}
							b-td {{row.teamMemberNo}}
							b-td {{row.teamMemberName}}
							b-td {{row.email}}
			div(v-if="d_pgKey=='RC'" class="small px-1")
				//- Header
				div(class="hdr")
					b-button(variant="primary" :disabled="!(d_rcData||[]).length" @click="m_clearRC()") Clear All
					b-button(variant="outline-secondary" @click="m_refresh()") Refresh
				//- Table
				b-table-simple(small hover)
					b-thead
						b-th(class="th-edit")
						b-th Request Time
						b-th User
						
						b-th(style={'width':'30px'}) Responses (all | user)
						b-th Path
						b-th Original URL
					b-tbody
						b-tr(v-for="(row,ixr) in d_rcData" :key="ixr" :class="")
							b-td
								span(class="btn btn-sm btn-link" @click="m_clearRC(row.reqId)") Clear
							b-td {{d_util.fn_fmtDtm(row.reqTs, true)}}
							b-td {{m_usrNm(row.auId)}}
							b-td {{row.res}} | {{row.resAu}}
							b-td {{row.pth}}
							b-td {{row.url}}



		//- Modal
		b-modal(
			id="bm-kt-admin"
			size="md" button-size="sm" header-class="py-2" header-bg-variant="light"
			body-class="py-2" footer-class="pt-0 flex-row-reverse" cancel-variant="outline-secondary"
			centered no-fade no-close-on-backdrop hide-header-close ok-title="Save"
			@ok="m_saveAU()"
			@cancel="d_rowModal={}"
			)
			div(class="mb-3")
				b-form-group(label="User Name" label-for="kt-bm-input-username")
					b-form-input(size="sm" id="kt-bm-input-username" v-model="d_rowModal.userName")
				b-form-group(label="User Sub" label-for="kt-bm-input-usersub")
					b-form-input(size="sm" id="kt-bm-input-usersub" v-model="d_rowModal.userSub")
				b-form-group(label="Disabled" label-for="kt-bm-input-disabled" v-if="d_rowModal.appUserId")
					b-form-checkbox(id="kt-bm-input-disabled" :value="true" v-model="d_rowModal.disabled")
				
				div(v-if="!d_rowModal.appUserId" class="border p-2" )
					p Team Member Record
					div(class="small d-flex")
						input(type="checkbox"  :value="false" v-model="d_rowModal.selTM")
						span Select an existing Team Member record
					kt-select(v-if="d_rowModal.selTM" id="kt-admin-add-user" ref="kt-select-add-user"
						p_appEntKey="team" p_noIcon=false p_filterKey="nonAppUsers"
						@change="d_rowModal.teamMember = $event")
					b-form-group(label="Name" label-for="kt-bm-input-teammembername" v-if="!d_rowModal.selTM")
						b-form-input(size="sm" id="kt-bm-input-teammembername" v-model="d_rowModal.name"  placeholder="Team Member Name")
					b-form-group(label="Email" label-for="kt-bm-input-email" v-if="!d_rowModal.selTM")
						b-form-input(size="sm" id="kt-bm-input-email" v-model="d_rowModal.email"  placeholder="Team Member Email")
			template(slot="modal-header")
				div(class="")
					span(class="mr-2") {{(d_rowModal.appUserId ? 'Edit ' : 'Add ') + 'App User'}}
					span(v-if="d_rowModal.appUserId")
						fa-icon(icon="key" size="sm" class="mr-1") 
						| {{d_rowModal.appUserId}}
</template>

 <script>
import { fn_getAdminData, fn_saveAdminData } from "@/utils/api.js";
import util, { kbdpAlert } from "@/utils/util.js";
export default {
  name: "kt-admin",
  components: {},
  created() {},
  mounted() {},
  data() {
    return {
      d_util: util,
      d_pgKey: null,
      d_auData: null,
      d_rowModal: {},
      d_rcData: null
    };
  },
  props: {},
  computed: {},
  methods: {
    m_refresh() {
      fn_getData(this, true);
    },
    m_goToMain() {
      if (this.$route.hash != '') {
        this.$router.push({
          name: 'KBDP'
        });
      }
    },
    m_addAU() {
      this.d_rowModal = {
        ix: null,
        appUserId: null,
        userName: null,
        userSub: null,
        teamMember: null,
        name: null,
        email: null
      };
      this.$bvModal.show('bm-kt-admin');
    },
    m_editAU(row, ixr) {
      this.d_rowModal = {
        ix: ixr,
        appUserId: row.appUserId,
        userName: row.userName,
        userSub: row.userSub,
        disabled: row.disabled
      };
      this.$bvModal.show('bm-kt-admin');
    },
    m_saveAU() {
      let rm = this.d_rowModal;
      let adminData = {
        appUserId: rm.appUserId,
        userName: rm.userName,
        userSub: rm.userSub,
        disabled: rm.disabled,
        teamMemberId: (rm.teamMember || {}).teamMemberId,
        name: rm.name,
        email: rm.email
      };
      let _this = this;
      kbdpAlert.showLoading();
      fn_saveAdminData('appUser', adminData).then(resp => {
        if (resp.error || !resp.adminData) {
          let msg = `Unable to save app user ` + (resp.error || '');
          kbdpAlert.showErr(msg);
          return;
        }
        kbdpAlert.clear();
        let saved = resp.adminData[0];
        if (rm.ix !== null) {
          //Existing
          _this.d_auData.splice(rm.ix, 1, saved);
        } else {
          //New
          _this.d_auData.push(saved);
        }
      });
    },
    m_usrNm(auId) {
      return ((this.d_auData || []).filter(x => x.appUserId == auId)[0] || {}).userName || auId;
    },
    m_clearRC(reqId) {
      let _this = this;
      fn_saveAdminData('cache', {
        reqId
      }).then(resp => {
        if (resp.error) {
          let msg = `Unable to complete request ` + (resp.error || '');
          kbdpAlert.showErr(msg);
          return;
        }
        if (reqId) util.fn_spliceById(_this.d_rcData, 'reqId', reqId);else _this.d_rcData = [];
      });
    }
  },
  watch: {
    d_pgKey() {
      fn_getData(this);
    }
  }
};
function fn_getData(vc, refresh) {
  switch (vc.d_pgKey) {
    case 'AU':
      {
        if (vc.d_auData && !refresh) return;
        kbdpAlert.showLoading();
        fn_getAdminData('appUsers').then(resp => {
          vc.d_auData = resp.adminData || [];
          kbdpAlert.clear();
        });
        break;
      }
    case 'RC':
      {
        if (vc.d_rcData && !refresh) return;
        kbdpAlert.showLoading();
        fn_getAdminData('cache').then(resp => {
          vc.d_rcData = resp || [];
          kbdpAlert.clear();
        });
        break;
      }
  }
}
</script>

<style lang="less">
#admin {
	display: flex;
	flex-wrap: nowrap;
	overflow-x: auto;
	min-height: calc(100vh - 150px);
	> div {
		text-align: left;
		&:first-child {
			flex-shrink: 0;
			width: 150px;
		}
		&:last-child {
			> div {
				white-space: nowrap;
			}
		}
	}
	.nav-tabs {
		border: none;
	}
	.nav-item {
		font-size: 0.8em;
		// background-color: white;
		a {
			padding: 0.2rem 0.2rem;
			margin: 0.3em 0;
			margin-left: 1em;
			border: none;
			border-left: solid 0.1em transparent;
		}
		a.active {
			font-weight: bold;
			border: none;
			border-radius: 0;
			border-left: solid 0.1em #4fa4ff;

			i.fa {
				color: #495057 !important;
			}
		}
		a:hover {
			border-radius: 0;
			border: none;
			border-left: solid 0.1em #4fa4ff;
			i.fa {
				color: #0056b3 !important;
			}
		}
	}
	.navbar-text {
		font-size: 0.9em;
		margin-left: 0.5rem;
		padding-bottom: 0;
		// border-bottom: solid 0.1em #495057;
	}

	div.hdr {
		.btn {
			padding: 0.1em 0.5em;
			margin-right: 0.5em;
			font-size: 0.9em;
			min-width: 80px;
		}
	}
	table {
		margin-bottom: 50px;
		thead {
			background-color: #f8f9fa;
			th {
				border-bottom: solid 0.2em #495057;
				vertical-align: middle;
			}

			th.th-edit {
				width: 40px;
			}
			th.th-id,
			th.th-chkBox {
				width: 75px;
			}
		}
		tbody {
			tr td {
				padding: 0.1em 0.4em;
			}
			tr td .btn-link {
				font-size: 1em;
				padding: 0;
			}
			tr td input[type="checkbox"] {
				pointer-events: none;
			}
		}
	}
}
#bm-kt-admin {
	.form-group {
		display: flex;
		label {
			width: 20%;
			font-size: 0.9em;
		}
		div {
			width: 80%;
		}
	}
	// div > input[type="checkbox"] + span {
	// 	display: inline-block;
	// 	line-height: 1em;
	// 	font-size: 0.9em;
	// 	padding-left: 0.5em;
	// 	margin-bottom: 1em;
	// }
	div.small.d-flex {
		margin-bottom: 1em;
		span {
			line-height: 1em;
			margin: auto 0.5em;
		}
	}
}
</style>
